<!-- MAIN CONTAINER -->
<div class="d-flex flex-column vh-100">

    <!-- FIXED SPACE FOR MAIN NAV BAR-->
    <div class="container">
        <div class="row my-3 py-3">
        </div>
    </div>

    <!-- LIST HEADER -->
    <div class="container">
        <div class="card card-body INN-form justify-content-center mt-4">
            <div class="row">

                <!-- LIST TITLE -->
                <div class="col-12 col-lg-5">
                    <h4 class="card-title lg-3 mb-lg-1 text-body-secondary">
                        <i class="bi bi-person-rolodex me-2 fs-1 text-primary"></i>Clientes
                    </h4>
                </div>

                <!-- FUNCTIONS CONTAINER -->
                <div class="col ms-2 m-lg-0 d-lg-flex justify-content-lg-end align-items-lg-center">

                    <!-- FUNCTIONS BUTTONS -->
                    <div class="col-12 col-lg-auto ms-0 ms-lg-2 mt-2 mt-lg-0"><button (click)="agregar(2)" class="INN-function-button link-opacity-50-hover text-decoration-none link-secondary fs-6"><i
                class="bi bi-file-earmark-plus me-2"></i>Agregar</button></div>

                    <!-- SEPARATION BAR -->
                    <div class="INN-functions-separation-bar mx-3 d-none d-lg-block"></div>

                    <!-- SEARCH FORM -->
                    <div class="col-12 col-lg-5 ms-0 mx-lg-2 mt-2 mt-lg-0">
                        <div class="input-group">
                            <input type="text" class="form-control" placeholder="Buscar" aria-label="Buscador" aria-describedby="boton-busqueda" [(ngModel)]="searchTerm" (keydown.enter)="search()">
                            <button class="btn btn-outline-secondary" type="button" id="boton-busqueda" (click)="search()"><i
                  class="bi bi-search"></i></button>
                        </div>
                    </div>

                </div>



            </div>
        </div>
    </div>

    <!-- LIST CONTENT -->
    <div class="container">
        <div class="p-0 p-md-3 card card-body INN-form justify-content-center mt-2">

            <!-- Display a loading message when users are loading -->
            <div *ngIf="!loading && clientes.length === 0">
                <p> {{mensajeClientes}} </p>
            </div>
            <!-- TABLE -->
            <table class="table mb-0 mb-md-3" *ngIf="!loading && clientes.length > 0">
                <thead>
                    <tr class="table-primary">
                        <th class="align-middle INN-tl-cell-rounded" scope="col">Razón Social</th>
                        <th class="INN-tr-cell-rounded" scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let cliente of clientes">
                        <tr class="table" *ngIf="cliente.Clt_Activo === true">
                            <th class="" scope="row">{{cliente.Clt_Razon_Social}}</th>
                            <td class="text-end">
                                <button (click)="editar(1, cliente)" class="INN-function-button p-0">
                              <i class="bi bi-arrow-up-right-square-fill link-secondary link-opacity-50-hover text-decoration-none fs-6"></i>
                            </button>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>

        </div>

    </div>

    <!-- LIST FOOTER -->
    <div class="container">
        <div class="card card-body INN-form justify-content-center mt-2 mb-4">
            <div class="row">

                <!-- PAGINATION -->
                <!-- <nav aria-label="Page navigation">
          <ul class="pagination justify-content-center mb-0">
            <li class="page-item disabled"><a class="page-link">Anterior</a></li>
            <li class="page-item active" aria-current="page"><a class="page-link" href="#">1</a></li>
            <li class="page-item"><a class="page-link" href="#">2</a></li>
            <li class="page-item"><a class="page-link" href="#">3</a></li>
            <li class="page-item"><a class="page-link" href="#">Siguiente</a>
            </li>
          </ul>
        </nav> -->

            </div>
        </div>
    </div>

    <div class="container">
        <div class="row mb-4 pb-4">
        </div>
    </div>

</div>
<!-- END MAIN CONTAINER -->